module.exports = __webpack_public_path__ + "img/home-users.df86c8a3.svg";